module.exports = __webpack_public_path__ + "img/login-v2.265f76d2.svg";